var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body bodys"},[_c('div',{staticClass:"login-top"}),_vm._v(" "),_c('div',{staticClass:"login-center"},[_c('Ptmember',{on:{"setPtzc":function($event){_vm.ptzc = 1}}})],1),_vm._v(" "),_c('div',{staticClass:"h-40"}),_vm._v(" "),_c('div',{staticClass:"login-botm"},[_vm._v(_vm._s(_vm.info.foot))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5a5440c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 